import UI from "./base/UI";
import {scrollTo} from "../functions/simple.ui";
import { isA11yCheckVersion } from "../functions/a11y.ui";
 
/**
 * Accordion
 */
/**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_accordion.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_accordion.html)
*/
class Accordion extends UI {
    defaults = {
        type: 'multi',
        state: undefined,
        no: undefined,
        defaultNo: undefined,
        scroll: false,
        action:undefined,
        activeType: 'inprogress',
    };

    constructor(el, options) {
        super('accordion', el);
        
        this.init(el, options);
    }

    init(el, options) {
        this.defaults = {...this.defaults, ...options};

        this.render();
        this.initOpenState();
    }

    update() {
        this.defaults.no = this.$el.attr('data-no')
        this.open(this.defaults.no);
    }

    render() {
        if(
            this.$el.find('.ui-accordion-btn').length > 0 &&
            this.$el.find('.ui-accordion-btn')[0].tagName.toLowerCase() === 'a' &&
            this.$el.find('.ui-accordion-btn').filter('a').length > 0 &&
            !this.$el.find('.ui-accordion-btn').attr('href')){
                this.$el.find('.ui-accordion-btn').attr('href', '#none');
        }
        
        if (this.$el.find('.ui-accordion-list').hasClass('open')) {
            this.$el.find('.ui-accordion-btn').attr('aria-expanded', true);
        } else {
            this.$el.find('.ui-accordion-btn').attr('aria-expanded', false);
        }
        
        this.detachEvents(); 
        this.attachEvents();

        if(isA11yCheckVersion()){
            this.a11yAriaExpand();
        }
    }

    initOpenState() {
        if (this.defaults.state === 'allOpen') {
            this.open('all');
        } else {
            if (this.$el.attr('data-default-no') != undefined) { //FETASK-1970 추가
                this.defaultOpen(this.$el.attr('data-default-no'), true);  
            } else {
                this.open(this.defaults.no);
            }
        }
    }

    attachEvents() {
        this.$el.on(`click${this.eventId}`, '.ui-accordion-btn', (e) => {
            e.preventDefault();
            const $this = $(e.currentTarget);
            const index = $this.closest('.ui-accordion-list').index() + 1;

            if (index != this.$el.attr('data-default-no')) {  //FETASK-1970 
                if (this.defaults.singlePrevent == undefined) {
                    if ($this.closest('.ui-accordion-list').hasClass('open')) {
                        this.close(index);
                    } else {
                        this.open(index);
                        this.defaults.scroll === true && this.scrollOpenPosition($this);
                    }
                } else {
                    if (!$this.closest('.ui-accordion-list').hasClass('open')) {
                        this.open(index);
                        this.defaults.scroll === true && this.scrollOpenPosition($this);
                    }
                }
            }
        });
    }

    /**
     * @summary 아코디언 open
     * @param index {String | Number} 'all', 'single', "2", "1, 3"
     */ 
    open(index) { 
        this.$el.find('.ui-accordion-btn').each((idx,el)=>{
            if (this.$el.attr('data-default-no') != idx+1) {
                $(el).attr('aria-expanded', false);
                 //A11YTASK-187 : : 접근성대응(2025-03-07)
                if($(el).parent().hasClass('open')){
                    $(el).attr('aria-expanded', true);
                } else {
                    $(el).attr('aria-expanded', false);
                }
                
            }
        })

        if (index === 'all') {
            this.$el.find('.ui-accordion-list').addClass('open');
            this.$el.find('.ui-accordion-btn').attr('aria-expanded', true);
            
            return;
        }
        const openList = index === 'object' ? index : this.parseOptions(index);

        if (this.defaults.type === "single" && this.defaults.action == undefined) {
            this.$el.find('.ui-accordion-list').removeClass('open');
            console.log('single')
            this.$el.find('.ui-accordion-btn').attr('aria-expanded', false); //A11YTASK-187 : : 접근성대응(2025-03-07)
        }
        openList.map((item) => {
            const target = this.$el.find('.ui-accordion-list').eq(item - 1);
                if (this.defaults.action === "slide") { //FETASK-1594 
                    target.siblings().removeClass('open')
                    target.siblings().find('.ui-accordion-cont').stop().slideUp(300)
                    target.find('.ui-accordion-cont').stop().slideDown(300);
                } 
                if (item != this.$el.attr('data-default-no')) { //FETASK-1970
                    target.addClass('open');
                    target.find('.ui-accordion-btn').attr('aria-expanded', true);
                }
        });
        
    }

    /**
     * @summary 아코디언 default active
     * @param index {String | Number} "2", "1, 3"
     */ 
    defaultOpen(index) { // FETASK-1970
        const openList = index === 'object' ? index : this.parseOptions(index);
        openList.map((item) => {
            const target = this.$el.find('.ui-accordion-list').eq(item - 1);
            if (this.$el.attr('data-default-no') != undefined) {
                target.addClass('open defalutOpen');
                target.find('.ui-accordion-btn').attr('aria-expanded', true);
            }
        });
    }


    /**
     * @summary 아코디언 close
     * @param index {String | Number} 'all', "2"
     */ 
    close(index) {
        if (index === 'all') {
            this.$el.find('.ui-accordion-list').removeClass('open');
            this.$el.find('.ui-accordion-btn').attr('aria-expanded', false);
           
            if (this.$el.attr('data-action') == 'slide') { // 챌린지박스 slide 아코디언 경우  close 할때  style  display:block 삭제
                this.$el.find('.ui-accordion-cont').each((idx,el)=>{
                    $(el).removeAttr('style')
                })
            }
            return;
        }

        const closeList = index === 'object' ? index : this.parseOptions(index);

        closeList.map((item) => {
            const target = this.$el.find('.ui-accordion-list').eq(item - 1);
            target.removeClass('open');
            

            if (item != this.$el.attr('data-default-no')) { //FETASK-1970
                target.find('.ui-accordion-btn').attr('aria-expanded', false);
            }

            if (target.find('.ui-expand').length > 0) { // FETASK-1081 | 230619 |  아코디언 안에 expand 있을때 닫히는 기능
                target.find('.ui-expand').each(function(idx,element){
                    $(element).data('ui').close($(element).find('.ui-expand-btn'))
                })
            }
        });
    }

    parseOptions(value) {
        let splitString;
        let numberArray = [];

        if (typeof value === 'string') {
            splitString = value.split(',');

            splitString.map((item) => {
                numberArray.push(+item);
            });

            value = numberArray;
        } else {
            value = [value];
        }

        return value;
    }

    scrollOpenPosition(target) {
        scrollTo(target);
        // if ($(target).attr('scroll-to') == undefined) {
        //      scrollTo(target);
        // } else {
        //     console.log($(target).attr('scroll-to'))
        //     scrollTo(Number($(target).attr('scroll-to')))
        // }
        
    }

    detachEvents() {
        this.$el.off(this.eventId);
    }

    destroy() {
        this.detachEvents();
    }

    a11yInit(){
        const ulWrap = this.$el;

        ulWrap?.find('.ui-accordion-list')?.removeAttr('aria-expanded');

        ulWrap.find('.ui-accordion-list').each((_, item) => {
            if($(item).hasClass('open')){
                $(item).find('.ui-accordion-btn').attr('aria-expanded','true');
                $(item).find('.ui-accordion-cont img').attr('alt','');
                $(item).find('.ui-accordion-cont a').attr('role','button');
            }else{
                $(item).find('.ui-accordion-btn').attr('aria-expanded','false');
                $(item).find('.ui-accordion-cont a').attr('role','button');
            }
        });
    }

    a11yAriaExpand(){
      
        const ulWrap = this.$el;

        const observerWrap = new MutationObserver((mutations) => {
            const target = $(mutations[0]?.target);
            console.log('open11')
            ulWrap?.find('.ui-accordion-list')?.removeAttr('aria-expanded');

            ulWrap.find('.ui-accordion-list').each((_, item) => {
                if($(item).hasClass('open')){
                    $(item).find('.ui-accordion-btn').attr('aria-expanded','true');
                    $(item).find('.ui-accordion-cont img').attr('alt','');
                    $(item).find('.ui-accordion-cont a').attr('role','button');
                    console.log('open')
                }else{
                    $(item).find('.ui-accordion-btn').attr('aria-expanded','false');
                    $(item).find('.ui-accordion-cont a').attr('role','button');
                    console.log('close')
                }
            });

            /*
            ulWrap.find('.ui-accordion-list').on('click',() => {
                // 클릭 발생시 기존 감지하던 MutationObserver 해제시킴 성능이슈 최적화, 그전까진 ajax로 DOM에 li들어오는거 감지해서 aria-expaned 속성 적용 해줘야함
                observerWrap.disconnect();
            });
            */
        });

        observerWrap.observe(ulWrap[0], {
            childList: true,
            subtree: true,
        });
    }
}

export default Accordion;
